import type { GridProps } from '@chakra-ui/react';
import { Grid, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import NetworkAddToWallet from 'ui/shared/NetworkAddToWallet';

import IntTxsIndexingStatus from './IntTxsIndexingStatus';

const Footer = () => {

  const renderNetworkInfo = React.useCallback((gridArea?: GridProps['gridArea']) => {
    return (
      <Flex
        gridArea={ gridArea }
        flexWrap="wrap"
        columnGap={ 8 }
        rowGap={ 6 }
        mb={{ base: 5, lg: 10 }}
        _empty={{ display: 'none' }}
      >
        { !config.UI.indexingAlert.intTxs.isHidden && <IntTxsIndexingStatus/> }
        <NetworkAddToWallet/>
      </Flex>
    );
  }, []);

  const renderFilingInfo = React.useCallback(() => {
    if (!config.UI.footer.filingNumber && !config.UI.footer.copyrightCompany) {
      return null;
    }
    return (
      <Text textAlign="center" fontSize="xs" color="text_secondary">
        { [ config.UI.footer.filingNumber, config.UI.footer.copyrightCompany ].filter(Boolean).join('　') }
      </Text>
    );
  }, []);

  const containerProps: GridProps = {
    as: 'footer',
    px: { base: 4, lg: 12 },
    py: { base: 4, lg: 9 },
    borderTop: '1px solid',
    borderColor: 'divider',
    gridTemplateColumns: { base: '1fr', lg: 'minmax(auto, 470px) 1fr' },
    columnGap: { lg: '32px', xl: '100px' },
  };

  const filingInfo = renderFilingInfo();

  if (config.UI.footer.links) {
    return (
      <Grid { ...containerProps }>
        <div>
          { renderNetworkInfo() }
        </div>
        { filingInfo && (
          <Text gridColumn={{ lg: '1 / -1' }} textAlign="center" fontSize="xs" color="text_secondary">
            { filingInfo }
          </Text>
        ) }
      </Grid>
    );
  }

  return (
    <Grid
      { ...containerProps }
      gridTemplateAreas={{
        lg: `
          "network links-top"
          ". links-bottom"
        `,
      }}
    >

      { renderNetworkInfo({ lg: 'network' }) }
      { filingInfo && (
        <Text gridColumn={{ lg: '1 / -1' }} textAlign="center" fontSize="xs" color="text_secondary">
          { filingInfo }
        </Text>
      ) }

      <Grid
        gridArea={{ lg: 'links-bottom' }}
        gap={ 1 }
        gridTemplateColumns={{
          base: 'repeat(auto-fill, 160px)',
          lg: 'repeat(3, 160px)',
          xl: 'repeat(4, 160px)',
        }}
        gridTemplateRows={{
          base: 'auto',
          lg: 'repeat(3, auto)',
          xl: 'repeat(2, auto)',
        }}
        gridAutoFlow={{ base: 'row', lg: 'column' }}
        alignContent="start"
        justifyContent={{ lg: 'flex-end' }}
        mt={{ base: 8, lg: 0 }}
      >
      </Grid>
    </Grid>
  );
};

export default React.memo(Footer);
